import { Version } from '@fuse/version/version';

export const FUSE_VERSION = new Version('13.3.1').full;
